// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Bw-z","tooltipWrapper":"Cw-z","icon":"Dw-z","tooltip":"Ew-z","content":"Fw-z"};